"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrCadGlobalSignalGroupingRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
class OrCadGlobalSignalGroupingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Group;
    }
    apply(manager, _hierarchy) {
        const scopedNames = this.collectPowerPortScopedNames(manager);
        const globalGroups = new Map();
        for (const group of manager.iterateGroups()) {
            for (const label of group.getNetLabels()) {
                if (label.labelType === 'global') {
                    const name = (label.formattedLabel ?? label.originalLabel).toUpperCase();
                    if (scopedNames.has(name)) {
                        continue;
                    }
                    if (!globalGroups.has(name)) {
                        globalGroups.set(name, new Set());
                    }
                    globalGroups.get(name).add(group);
                }
            }
            for (const [, nets] of group.getNets()) {
                for (const net of nets) {
                    for (const conn of net.connections) {
                        if (conn.connection.appliesNetName?.labelType === 'global') {
                            const name = conn.connection.appliesNetName.label.toUpperCase();
                            if (scopedNames.has(name)) {
                                continue;
                            }
                            if (!globalGroups.has(name)) {
                                globalGroups.set(name, new Set());
                            }
                            globalGroups.get(name).add(group);
                        }
                    }
                }
            }
        }
        for (const groups of globalGroups.values()) {
            if (groups.size <= 1) {
                continue;
            }
            manager.mergeGroups(...Array.from(groups));
        }
        return manager;
    }
    collectPowerPortScopedNames(manager) {
        const scoped = new Set();
        for (const group of manager.iterateGroups()) {
            for (const label of group.getNetLabels()) {
                if (label.labelType !== 'hierarchical-port') {
                    continue;
                }
                scoped.add((label.formattedLabel ?? label.originalLabel).toUpperCase());
            }
        }
        return scoped;
    }
}
exports.OrCadGlobalSignalGroupingRule = OrCadGlobalSignalGroupingRule;
//# sourceMappingURL=OrcadGlobalSignalGroupingRule.js.map